import React, { useRef } from 'react';

const UploadIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 14.9A5 5 0 0 1 6 5.3a6 6 0 0 1 11.3 2A4.5 4.5 0 0 1 19 16" />
        <polyline points="9 15 12 12 15 15" /><line x1="12" y1="12" x2="12" y2="20" />
    </svg>
);

const SearchIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
);

const UploadBox = ({ icon = 'upload', title, subtitle, onFile, onClick, previewUrl, style }: any) => {
    const fileRef: any = useRef(null);

    const handleBoxClick = () => {
        if (onClick) { onClick(); return; }
        fileRef.current?.click();
    };

    const handleFileChange = (e: any) => {
        const file = e.target.files?.[0];
        if (file) onFile?.(file);
    };

    return (
        <button style={style} type="button" className="cs-upload-box" onClick={handleBoxClick}>
            {previewUrl ? (
                <img src={previewUrl} alt="" className="cs-upload-box__preview" />
            ) : (
                <>
                    <span className="cs-upload-box__icon">
                        {icon === 'search' ? <SearchIcon /> : <UploadIcon />}
                    </span>
                    <span className="cs-upload-box__title">{title}</span>
                    {subtitle && <span className="cs-upload-box__subtitle">{subtitle}</span>}
                </>
            )}
            {!onClick && (
                <input
                    ref={fileRef}
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleFileChange}
                />
            )}
        </button>
    );
};

export default UploadBox;